export type BenefitIconName = 'location' | 'alert' | 'steps' | 'health' | 'community';

/**
 * The glyph for each line of "What {pet} gets": one ink colour on a near-black disc, so the icons tell
 * the lines apart by shape and colour stays reserved for the pay button and the savings in the summary.
 */
export function BenefitIcon({ name }: { name: BenefitIconName }) {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="10" cy="10" r="10" fill="#100f0e" />
      {name === 'location' && (
        <>
          <path
            d="M10 4.5c-2 0-3.3 1.5-3.3 3.3 0 2.3 3.3 6.2 3.3 6.2s3.3-3.9 3.3-6.2c0-1.8-1.3-3.3-3.3-3.3z"
            fill="#ffffff"
          />
          <circle cx="10" cy="7.8" r="1.3" fill="#100f0e" />
        </>
      )}
      {name === 'alert' && (
        <>
          <path d="M10 4.5c-2 0-3.2 1.5-3.2 3.4v2.2L5.8 12h8.4l-1-1.9V7.9c0-1.9-1.2-3.4-3.2-3.4z" fill="#ffffff" />
          <circle cx="10" cy="14.2" r="1.2" fill="#ffffff" />
        </>
      )}
      {name === 'steps' && (
        <>
          <ellipse cx="7.5" cy="8" rx="1.6" ry="2.3" fill="#ffffff" />
          <ellipse cx="12.5" cy="12" rx="1.6" ry="2.3" fill="#ffffff" />
        </>
      )}
      {name === 'health' && (
        <path
          d="M4 10.5h3l1.5-3.5 2.5 6.5 1.5-3H16"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {name === 'community' && (
        <>
          <circle cx="7.5" cy="8" r="1.8" fill="#ffffff" />
          <circle cx="12.5" cy="8" r="1.8" fill="#ffffff" />
          <path d="M4.5 14c0-2 1.4-3 3-3s3 1 3 3zM9.5 14c0-2 1.4-3 3-3s3 1 3 3z" fill="#ffffff" />
        </>
      )}
    </svg>
  );
}
